import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=403897b0&scoped=true&"
import script from "./product-card.vue?vue&type=script&lang=js&"
export * from "./product-card.vue?vue&type=script&lang=js&"
import style0 from "./product-card.vue?vue&type=style&index=0&id=403897b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403897b0",
  null
  
)

export default component.exports